// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.1
//   protoc               v3.19.1
// source: xeam/common/workspace.proto

/* eslint-disable */

export const protobufPackage = "xeam.common";

export const protobufFileName = "xeam/common/workspace.proto";

export enum WorkspaceOwnerType {
  PERSONAL = 0,
  ORGANIZATION = 1,
}
